var crypto = window.crypto || window.msCrypto

module.exports = function (bytes) {
  return crypto.getRandomValues(new Uint8Array(bytes))
}



//////////////////
// WEBPACK FOOTER
// ./~/nanoid/random-browser.js
// module id = 963
// module chunks = 0